export const INSTRUCTION_ITEM_HEIGHT = 80;
export const INSTRUCTION_ITEM_WIDTH = 78;
export const INSTRUCTION_ITEM_HEIGHT_UX4 = 88;
export const INSTRUCTION_ITEM_WIDTH_UX4 = 90;
export const INSTRUCTION_ITEM_VISIBILITY_THRESHOLD = 1;
